var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"woocommerce-Price-amount amount",class:{ negative: ( _vm.amount < 0 ) }},[_vm._v(_vm._s(_vm.formatAmount(_vm.amount)))])}
var staticRenderFns = []

export { render, staticRenderFns }